import {
  ERROR_UNALLOCATED_POSTCODES,
  WARNING_UNALLOCATED_POSTCODES,
} from "../../../consts/strings";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { memo, useEffect, useState } from "react";
import { take, takeRight } from "lodash";

import clsx from "clsx";

const useStyles = makeStyles({
  listItem: {
    fontSize: "12px",
    lineHeight: "14px",
    margin: "10px 0",
  },
  additionalItems: {
    color: "rgba(0, 0, 0, 0.5)",
  },
});

export const UnallocatedPostcodesContent = memo(({ postcodes = [], error }) => {
  const styles = useStyles();
  const [firstPostcodes, setFirstPostcodes] = useState([]);
  const [remainingPostcodes, setRemainingPostcodes] = useState();

  useEffect(() => {
    if (!Array.isArray(postcodes)) return;

    setFirstPostcodes(take(postcodes, 6));
    setRemainingPostcodes(takeRight(postcodes, postcodes.length - 6));
  }, [postcodes]);

  return (
    <>
      <Typography>
        {error ? ERROR_UNALLOCATED_POSTCODES : WARNING_UNALLOCATED_POSTCODES}
      </Typography>
      {Array.isArray(firstPostcodes) &&
        firstPostcodes.map((postcode, index) => {
          return (
            <div key={index}>
              <div className={styles.listItem}>{postcode}</div>
            </div>
          );
        })}
      {Array.isArray(remainingPostcodes) && remainingPostcodes.length > 0 && (
        <div className={clsx(styles.listItem, styles.additionalItems)}>
          +{remainingPostcodes.length} Other Areas
        </div>
      )}
    </>
  );
});
